import PersonMedications from './PersonMedications';

export default PersonMedications;
